import RouteView from '@/router/RouteView.vue';
import PackageList from './packageList/index.vue';
import packageDetail from './packageDetail/index.vue';

export default [
  {
    path: '/packageList',
    name: 'PackageList',
    component: PackageList,
    meta: {
      title: '我的课程',
    },
  },
  {
    path: '/packageList',
    component: RouteView,
    meta: {
      title: '课程列表',
    },
    children: [
      {
        path: '/packageList/packageDetail',
        name: 'packageDetail',
        component: packageDetail,
        meta: {
          title: '课程详情',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/MyCourse/router.js